import { MUSICAL_KEYS } from "../data/keys"

export const getUniqueRoots = () => {
    return [...new Set(MUSICAL_KEYS.map(key => key.root))];
}

export const getUniqueTypes = () => {
    return [...new Set(MUSICAL_KEYS.map(key => key.type))];
}
